import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ObjectUtils } from '@cv-invision/core';
// Actions
import { SetOrderDetailPipelines, SetOrderLocked, SetOrderStateEnum, SetOrderUnlocked } from './actions/quality-order-detail.actions';
// Models
import { OrderCI_ORDERDETAIL_STATE_PATH, OrderDetailModel, OrderLockedBy } from './model/order-detail.model';

@State<OrderDetailModel>({
	name: OrderCI_ORDERDETAIL_STATE_PATH,
	defaults: new OrderDetailModel()
})
@Injectable()
export class QualityOrderDetailState {

	/**
	 * Get Feature Quality Order Detail State Model.
	 * @param state: OrderDetailModel
	 */
	@Selector()
	static getOrderDetail(state: OrderDetailModel): OrderDetailModel {
		return state;
	}

	/**
	 * Get Order Lock Status State Model.
	 * @param state: OrderDetailModel
	 */
	@Selector()
	static getOrderLockedBy(state: OrderDetailModel): OrderLockedBy {
		return state.lockedBy;
	}

	/**
	 * Set Order to locked state
	 * @param ctx
	 * @param locked
	 * @param lockedBy
	 * @constructor
	 */
	@Action(SetOrderLocked)
	SetOrderLocked(ctx: StateContext<OrderDetailModel>, { locked, lockedBy }: SetOrderLocked): void {
		ctx.patchState({
			locked,
			lockedBy
		});
	}

	/**
	 * Set Order to unlocked state
	 * @param ctx
	 * @constructor
	 */
	@Action(SetOrderUnlocked)
	SetOrderUnlocked(ctx: StateContext<OrderDetailModel>): void {
		const locked = null;
		const lockedBy = null;
		ctx.patchState({
			locked,
			lockedBy
		});
	}

	/**
	 * Set Pipeline Indicators
	 * @param ctx
	 * @param PipelineConfig
	 */
	@Action(SetOrderDetailPipelines)
	SetOrderDetailPipelines(ctx: StateContext<OrderDetailModel>, { pipelineConfig }: SetOrderDetailPipelines): void {
		let currentPipelines = ObjectUtils.recursiveDeepCopy(ctx.getState().pipelineIndicators);
		const result = currentPipelines.map(item1 => {
			const item2 = pipelineConfig.find(item2 => item2.key === item1.key);
			return { ...item1, ...item2 };
		});
		ctx.patchState({
			pipelineIndicators: result
		});
	}

	/**
	 * Set Order stateEnum value
	 * @param ctx
	 * @constructor
	 */
	@Action(SetOrderStateEnum)
	SetOrderStateEnum(ctx: StateContext<OrderDetailModel>, { stateEnum }: SetOrderStateEnum): void {
		ctx.patchState({
			stateEnum
		});
	}
}
